export class ReportIssueConfiguration {

    Title: string | null = null;
    Type: ReportIssueType | null = null;
    ButtonLabel: string | null = null;

    constructor() { }

    public static create = (): ReportIssueConfiguration => new ReportIssueConfiguration();

    setTitle(value: string) {

        this.Title = value;
        return this;
    }
    setType(value: ReportIssueType) {

        this.Type = value;
        return this;
    }
    setButtonLabel(value: string) {

        this.ButtonLabel = value;
        return this;
    }

}

export enum ReportIssueType {

    SALE = 1,
    RESALE = 2

}